/**
 * ForecastQuantityForecast
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectQuantityForecastValue } from '../../services/quantityForecasts/selectors';

interface Props {
    value?: ?number;
}

export class ForecastQuantityForecast extends React.PureComponent<Props> {
    render() {
        const { value } = this.props;
        if (!value && value !== 0) return null;
        return value;
    }
}

const mapStateToProps = createStructuredSelector({
    value: makeSelectQuantityForecastValue('value')
});

export default connect(mapStateToProps)(ForecastQuantityForecast);
